module.exports = __webpack_public_path__ + "static/media/zhongcang.95c070ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/zhongcang.png
// module id = 2188
// module chunks = 0